import { Dialog, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseIcon.svg"
import ListComponent from './ListComponent';
import ALoader from 'views/pages/manage/common/a-loader';

const ViewHistoryDialog = ({
    isOpen,
    handleClose = () => { },
    isLoading,
    rows
}) => {

    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="md"
        // scroll="paper"
        >
            {isLoading && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between'>
                    <h4>Address History</h4>
                    <CloseIcon onClick={handleClose} />
                </div>

                <ListComponent
                    rows={rows}
                    rowCount={rows?.length || 0}
                />

            </div>
        </Dialog>
    )
}

export default ViewHistoryDialog;